import { render, staticRenderFns } from "./IconRight.vue?vue&type=template&id=34afae8b&scoped=true&"
import script from "./IconRight.vue?vue&type=script&lang=js&"
export * from "./IconRight.vue?vue&type=script&lang=js&"
import style0 from "./IconRight.vue?vue&type=style&index=0&id=34afae8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34afae8b",
  null
  
)

export default component.exports